/**
 * The send hour as a reader would say it. Whole hours only: the platform sends on the
 * hour, and "8:00 AM" would imply a precision the schedule does not have.
 */
export function formatSendHour(hourLocal: number): string {
  const suffix = hourLocal < 12 ? "am" : "pm";
  const twelve = hourLocal % 12 === 0 ? 12 : hourLocal % 12;
  return `${twelve}${suffix}`;
}
